const QUERIES = {
  JOB_LIST: 'job',
  APPLICATION_LIST: 'application',
  COMMENT_LIST: 'comment',
  CONTACT_US_LIST: 'contact-us',
  BUSINESS_LIST: 'business',
  BLOG_LIST: 'blog',
  BLOG_TOPIC_LIST: 'blog-topic',
  DOC_LIST: 'docs',
}

export {QUERIES}
